<template>
  <Header headerShadow="header__area header__padding header__padding-2 header__shadow " />
  <Breadcrumb title="Sitemap" />
  <section class="cart-area pt-100 pb-100">
    <div class="container">
      <div class="row">
        <div class="col-12">
          ...
        </div>
      </div>
    </div>
  </section>
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Home/Header';
import Footer from '../components/Home/Footer.vue';
import Breadcrumb from "@/components/common/Breadcrumb.vue";

export default {
  name:'SitemapPage',
  components:{
    Breadcrumb,
    Header,
    Footer,
  }
}
</script>

